import { en } from './en';
import { hi } from './hi';
import { bn } from './bn';
import { te } from './te';
import { ta } from './ta';
import { kn } from './kn';
import { gu } from './gu';
import type { ConsentText } from './types';

export type { ConsentText } from './types';

/** The consent document's languages: English, and the six it is translated into (owner, 2026-09-28). */
export const CONSENT_TEXTS: Record<string, ConsentText> = { en, hi, bn, te, ta, kn, gu };

/** The text for a language, or null when the document is not translated into it (it then goes in English only). */
export function consentTextFor(code: string | null | undefined): ConsentText | null {
  return CONSENT_TEXTS[(code ?? '').slice(0, 2).toLowerCase()] ?? null;
}

/** The copies a consent is made in: English always, and the consent's own language when translated. */
export function consentCopyLanguages(code: string | null | undefined): string[] {
  const lang = (code ?? 'en').slice(0, 2).toLowerCase();
  return lang !== 'en' && CONSENT_TEXTS[lang] ? ['en', lang] : ['en'];
}
